module.exports = __webpack_public_path__ + "static/media/Residential_21.aec26ffe.jpg";